import { Link } from "react-router-dom";

const chips = [
  { icon: "ri-book-open-fill", label: "双页模式" },
  { icon: "ri-align-vertically", label: "滚动阅读" },
  { icon: "ri-moon-fill", label: "夜间模式" },
  { icon: "ri-list-check-3", label: "目录跳转" },
  { icon: "ri-history-fill", label: "进度记忆" },
];

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[640px] md:min-h-[720px] items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=artistic%20stylized%20flat%20illustration%20of%20a%20cozy%20reading%20corner%20at%20night%20with%20a%20glowing%20tablet%20displaying%20comic%20pages%2C%20floating%20manga%20panel%20fragments%20and%20books%20around%2C%20warm%20vermilion%20and%20deep%20amber%20palette%20with%20soft%20shadows%2C%20modern%20minimal%20vector%20style%2C%20clean%20composition%2C%20atmospheric%20moody%20lighting&width=1600&height=900&seq=hero-mgb-2026&orientation=landscape"
        alt="MGB漫画网夜间沉浸式阅读插画"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-24 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur">
          <i className="ri-sparkling-2-line text-accent-400"></i>
          主打阅读体验的漫画阅读平台
        </span>

        <h1 className="mx-auto mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          把漫画，读得流畅又顺手
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          MGB漫画网阅读页支持双页模式与滚动阅读自由切换，夜间模式保护眼睛，图片加载流畅不卡顿，目录跳转快速定位章节，进度记忆自动保存，下次打开接着看。
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2.5">
          {chips.map((c) => (
            <span
              key={c.label}
              className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3.5 py-1.5 text-xs text-background-50 backdrop-blur"
            >
              <i className={`${c.icon} text-accent-400`}></i>
              {c.label}
            </span>
          ))}
        </div>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/reader"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            立即体验阅读
          </Link>
          <a
            href="#popular"
            className="whitespace-nowrap rounded-md border border-background-50/40 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
          >
            浏览热门作品
          </a>
        </div>
      </div>
    </section>
  );
}